export const YANDEX_METRIKA_HOME_URL = 'https://metrika.yandex.ru/';
export const getYandexMetrikaCounterUrl = (id: string) => `${YANDEX_METRIKA_HOME_URL}overview?id=${id}`;

export const YANDEX_DIRECT_HOME_URL = 'https://direct.yandex.ru/';

export const YANDEX_MERCHANTS_HOME_URL = 'https://merchants.yandex.ru/';
export const YANDEX_MERCHANTS_FEED_URL = `${YANDEX_MERCHANTS_HOME_URL}feed`;
export const YANDEX_MERCHANTS_FEED_LIST_URL = `${YANDEX_MERCHANTS_FEED_URL}?tab=list`;
